import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import {
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { APP_ROUTES } from './routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { AuthService } from './app/core/auth/auth.service';
import { authAppInitializerFactory } from './app/core/auth/auth-app-initializer.factory';
import { MAT_RIPPLE_GLOBAL_OPTIONS, provideNativeDateAdapter } from '@angular/material/core';
import { FsxGlobalRippleOptions } from './app/services/material/fsx-global-ripple-options.service';
import {fsxInterceptor} from './app/core/interceptors/fsx.interceptor.service';
import { provideFsxComponentLibrary } from 'fsx-component-library';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useExisting: FsxGlobalRippleOptions,
    },
    provideHttpClient(withInterceptors([fsxInterceptor])),
    provideRouter(
      APP_ROUTES,
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    importProvidersFrom(BrowserAnimationsModule),
    provideNativeDateAdapter(),
    provideHttpClient(),
    provideOAuthClient(),
    provideAppInitializer(() => {
      const initializerFn = authAppInitializerFactory(inject(AuthService));
      return initializerFn();
    }),
    provideFsxComponentLibrary()
  ],
}).catch((err) => console.error(err));
